import Vue from 'vue'
import Router from 'vue-router'
import tiwn from '@/components/tiwn'
import more from '@/components/more'
import result from '@/components/result'
import calendar from '@/components/calendar'
import moreResult from '@/components/moreResult'
import my from '@/components/my'
import recordList from '@/components/recordList'
import share from '@/components/share'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      redirect:'/tiwn'
    },
    {
      path: '/tiwn',
      name: 'index',
      component: tiwn,
    },
    {
      path: '/more',
      name: 'index',
      component: more,
    },
    {
      path: '/result',
      name: 'index',
      component: result,
    },
    {
      path: '/moreResult',
      name: 'index',
      component: moreResult,
    },
    {
      path: '/my',
      name: 'my',
      component: my,
    },
    {
      path: '/recordList',
      name: 'recordList',
      component: recordList,
    },
    {
      path: '/share',
      name: 'share',
      component: share,
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: calendar,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js